import { ReactNode } from 'react';

import { showcaseSurfacePanelClassName } from '../helpers/showcaseSurfacePanelClassName';

type TProps = {
  title: string;
  children: ReactNode;
  surface?: boolean;
};

export const Section = ({ title, children, surface = false }: TProps) => (
  <section className="mb-8">
    <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-[var(--color-text-muted)]">{title}</h2>
    {surface ? <div className={showcaseSurfacePanelClassName}>{children}</div> : children}
  </section>
);
